import { Button } from "@heroui/react";

/** The classes of the small white button of a status row («Riprova», «Carica altre»). */
export const STATUS_BUTTON_CLASS =
  "h-7 min-w-8 gap-1 rounded-2xl bg-white px-2.5 py-1 text-xs leading-5 font-medium text-field-placeholder shadow-field";

type PanelStatusProps = {
  children: React.ReactNode;
  onRetry?: () => void;
  /** The button's words, «Riprova» unless the retry is something else («Riprova ad accedere»). */
  retryLabel?: string;
  /**
   * "status" (a live region: loading, empty), "alert" (an error), or "note":
   * a neutral notice that is read in place, not announced. The look is the same.
   */
  role?: "status" | "alert" | "note";
  /** Indented as a line of the sources tree (the panels); false under a list of cards. */
  indent?: boolean;
  /** For aria-controls, when a button shows and hides the row. */
  id?: string;
};

/** A status row (loading, error, empty): neutral text, with «Riprova» when there is something to retry. */
export function PanelStatus({ children, onRetry, retryLabel = "Riprova", role = "status", indent = true, id }: PanelStatusProps) {
  return (
    <div
      id={id}
      role={role}
      className={`flex flex-wrap items-center gap-2.5 py-2 text-sm leading-6 text-muted ${indent ? "pl-7" : ""}`}
    >
      <span>{children}</span>
      {onRetry && (
        <Button size="sm" onPress={onRetry} className={STATUS_BUTTON_CLASS}>
          {retryLabel}
        </Button>
      )}
    </div>
  );
}
